import { render, staticRenderFns } from "./habitHome.vue?vue&type=template&id=6a63d966&scoped=true"
import script from "./habitHome.vue?vue&type=script&lang=js"
export * from "./habitHome.vue?vue&type=script&lang=js"
import style0 from "./habitHome.vue?vue&type=style&index=0&id=6a63d966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63d966",
  null
  
)

export default component.exports